import colors from '../TCP/colors';
import orange from '../colors/orange';

const gymColors = {
  ...colors,
  PRIMARY_BUTTON_BORDER_COLOR: orange[800],
  NOTIFICATION_PROMPT_WRAPPER: '#ffffff',
  ITEM_COUNT_WRAPPER: orange[900],
  PLP_SIDEBAR_SUBCATEGORY_BORDER: orange[800],
  PLP_SIDE_NAVBAR_SUBHEADER_BORDER: orange[800],
};

export default gymColors;
